(function () {
  'use strict';

  // Remove legacy simulated ratings only. Real review widgets use their own markup and remain untouched.
  function removeLegacyDemoRatings(root) {
    if (!root) return;
    if (root.nodeType === 1 && root.matches && root.matches('.lovirs-demo-rating')) {
      root.remove();
      return;
    }
    if (root.querySelectorAll) {
      root.querySelectorAll('.lovirs-demo-rating').forEach(function (element) { element.remove(); });
    }
  }
  removeLegacyDemoRatings(document);
  if (document.documentElement) {
    var legacyRatingObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(removeLegacyDemoRatings);
      });
    });
    legacyRatingObserver.observe(document.documentElement, { childList: true, subtree: true });
  }


  function initLovirsQuickAddEnhancements() {
    var dialogRoot = document.getElementById('quick-add-dialog');
    if (!dialogRoot || dialogRoot.dataset.lovirsEnhancementsReady === 'true') return;
    dialogRoot.dataset.lovirsEnhancementsReady = 'true';

    function enhanceQuickAdd() {
      var content = dialogRoot.querySelector('#quick-add-modal-content') ||
        dialogRoot.querySelector('.quick-add-modal__content');
      if (!content) return;

      var productDetails = content.querySelector('.product-details');
      if (!productDetails) return;

      if (!productDetails.querySelector('.lovirs-quick-add-details')) {
        var description = productDetails.querySelector('.text-block.rte, rte-formatter.text-block');
        if (description && description.textContent && description.textContent.trim().length > 0) {
          var disclosure = document.createElement('details');
          disclosure.className = 'lovirs-quick-add-details';
          var summary = document.createElement('summary');
          summary.textContent = 'More product details';
          var body = document.createElement('div');
          body.className = 'lovirs-quick-add-details__body';
          var parent = description.parentNode;
          parent.insertBefore(disclosure, description);
          disclosure.appendChild(summary);
          disclosure.appendChild(body);
          body.appendChild(description);
        }
      }
    }

    var observer = new MutationObserver(function () {
      window.requestAnimationFrame(enhanceQuickAdd);
    });
    observer.observe(dialogRoot, { childList: true, subtree: true });
    dialogRoot.addEventListener('click', function () {
      window.setTimeout(enhanceQuickAdd, 0);
    });
    enhanceQuickAdd();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLovirsQuickAddEnhancements, { once: true });
  } else {
    initLovirsQuickAddEnhancements();
  }
})();